module.exports = __webpack_public_path__ + "img/playbutton18.e744ba34.png";